export interface CmpsCardRowProgressData {
    progressBarValues: CmpsCardRowProgressBarValue[];
    progressTooltipData: CmpsCardRowTooltipValue[];
}
export interface CmpsCardRowProgressBarValue {
    thresholdValue?: string;
    actualValue?: string;
    opportunityColor: string;
}
export interface CmpsCardRowTooltipValue {
    label: string;
    value: string;
}
export interface CmpsCardRowData {
    dataRowNameLabel: string;
    percentageValue?: string;
    opportunityColor?: string;
    rowType?: RowType;
    isVisible?: boolean;
    placeholderStr?: string;
    menuTooltipData?: CmpsCardRowTooltipValue[];
    trendId?: TrendType;
    trendColor?: string;
    noDataLabel?: string;
}

export interface CmpsCardRowMenuData {
    dropdownMenuValues: CmpsCardRowMenuItem[];
}
export interface CmpsCardRowMenuItem {
    value: string;
    id: number;
    selected?: boolean;
    subMenu?: CmpsCardRowSubMenuItem[];
}
export interface CmpsCardRowSubMenuItem {
    value: string;
    id: number;
    selected: boolean;
}

export enum RowType {
    OA,
    OA_CHILD,
    MI2,
    FLOA,
    WP, // winning %
    FLMI2,
    FLWP, // Front Line Winning %
}

export enum TrendType {
    UNKNOWN,
    UP,
    DOWN,
    NEUTRAL,
}
